import { Configure, Index, useHits, useInstantSearch, useSearchBox } from "react-instantsearch";
import { Skeleton } from "../../search-results/components/ui/Skeleton";
import { VirtualSearchBox } from "../../search-shared/VirtualSearchBox";
import { searchIndexes } from "../../search-shared/client";
import SimpleResult from "./SimpleResult";
import NoResults from "../../search-results/components/NoResults";
import { capitalizeFirstLetter } from "../../utils/capitalise";
import { ScrollArea } from "../../components/ui/ScrollArea";
import { useIndexName } from "../../search-results/components/IndexNameProvider";

const listClasses = "tw-space-y-1 tw-text-black xl:tw-mt-2 [&_li]:tw-text-base";

function TheHits({ index }: { index: "collections" | "brands" }) {
    const { status } = useInstantSearch();
    const { items } = useHits();

    const onSelect = (handle: string) => {
        const baseUrl = window.location.origin;
        const path = index === "collections" ? `/collections/${handle}` : `/pages/${handle}`;
        window.location.href = `${baseUrl}${path}`;
    }

    if (status === "loading" || status === "stalled") {
        return Array(4).fill(null).map((_, index) => (
            <Skeleton key={index} className="h-[21px] mx-2 my-1 bg-gray-200" />
        ))
    }

    return (
        <div className="CollectionBrandsHits">
            <h3 className="tw-hidden xl:tw-block tw-text-lg">{capitalizeFirstLetter(index)}</h3>

            <ScrollArea orientation="horizontal" className="tw-max-w-full tw-pb-3">
                {!items.length ? <NoResults /> : (
                    <>
                        <ul className={listClasses}>
                            {items.map((item) => (
                                <li key={item.objectID}>
                                    <SimpleResult onSelect={() => onSelect(item.handle)} text={item.title} />
                                </li>
                            ))}
                        </ul>
                    </>
                )}
            </ScrollArea>
        </div>
    );
}

export function CollectionsHits({ showOnIndex = searchIndexes.COLLECTIONS }) {
    const { query } = useSearchBox();
    const { indexName: currentIndex } = useIndexName();

    return (
        <Index indexName={searchIndexes.COLLECTIONS}>
            <VirtualSearchBox />
            <Configure hitsPerPage={window.algoliaShopify.config.collections_autocomplete_hits_per_page ?? 4} query={query} />

            {currentIndex === showOnIndex && (
                <TheHits index="collections" />
            )}
        </Index>
    );
}

export function BrandsHits({ showOnIndex = searchIndexes.BRAND_PAGES }) {
    const { query } = useSearchBox();
    const { indexName: currentIndex } = useIndexName();

    return (
        <Index indexName={searchIndexes.BRAND_PAGES}>
            <VirtualSearchBox />
            <Configure hitsPerPage={window.algoliaShopify.config.pages_autocomplete_hits_per_page ?? 4} query={query} />

            {currentIndex === showOnIndex && (
                <TheHits index="brands" />
            )}
        </Index>
    );
}
